import { render, staticRenderFns } from "./MicrosoftLoginButton.vue?vue&type=template&id=4ba487ea&"
import script from "./MicrosoftLoginButton.vue?vue&type=script&lang=js&"
export * from "./MicrosoftLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports